module.exports = __webpack_public_path__ + "static/media/saoa1.e2b73820.png";